import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.public.user-accounts.edit', {
        url: '/:publicUserAccountId/edit',
        params: { publicUserAccount: {}},
        resolve: {
            publicUserAccountId,
            publicUserAccount,
        },
        views: {
            '@user': 'publicUserAccountsEdit',
        },
    });
}

/** @ngInject */
function publicUserAccountId($stateParams) {
    return $stateParams.publicUserAccountId;
}

/** @ngInject */
function publicUserAccount(publicUserAccountId, publicUserAccounts) {
    return publicUserAccounts.find(account => account.id === publicUserAccountId);
}



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/edit/edit-public-user-account.state.js